export default {
  home: {
    minute: "minute",
    price_info: "Une caution de {currencyName}{yajin} sera débitée de votre carte et remboursée sous 2 à 5 jours ouvrables après le retour du power bank. Tarif journalier plafonné à {currencyName}{fengding}. Si conservé plus de {overtime} heures, des frais de {currencyName}{overtimeAmount} vous seront facturés, et le chargeur vous appartiendra.",
    feature_1: " - Retournez le power bank dans n'importe quelle BlitzStation disponible",
    feature_2: " - USB-C, Lightning et Micro USB inclus",
    feature_3: "Recharge sans fil disponible",
    tips_1: "Votre caution de {currencyName}{yajin} sera restituée à la fin de la location",
    tips_2: "La caution de recharge {currencyName}{yajin} peut être utilisée pour la location, et lorsqu'elle est épuisée, elle peut être remboursée",
    tips_3: "Le solde actuel est de {currencyName}{myyue}, qui peut être utilisé directement pour la location",
    submit: "Commencer la location",
    borrow: "Louer",
    msg_fail_title: "Erreur",
    msg_fail_content: "Échec de la location, veuillez réessayer",
    msg_rentcount: "Vous avez actuellement {zujieNum} commandes non clôturées",
    goborrow: "Commencer",
    nearby: "Voir les stations à proximité",
    preauth: "Pré-autorisation"
  },
  login: {
    code_title: "Vérification par SMS",
    phone_number: "Numéro de téléphone",
    verification_code: "Veuillez entrer le code de vérification",
    captcha_code: "Code",
    send_code: "Envoyer le code",
    login: "Connexion",
    agree: "En cliquant sur Connexion, vous acceptez ",
    readme: "Conditions d'utilisation",
    msg_fail_login: "Échec de la connexion",
    msg_success_login: "Connexion réussie",
    msg_fail_user: "Erreur lors de la récupération des informations utilisateur. Voulez-vous réessayer ?",
    sign_in_with: "Se connecter avec",
    no_sms: "Vous n'avez pas reçu le message",
    retry: "Renvoyer",
    login_with_phone: "Se connecter avec téléphone",
    login_with_email: "Se connecter avec e-mail",
    email: "E-mail"
  },
  confirm: {
    deletecard: "Supprimer la carte",
    addcard: "Entrer les détails de la carte",
    title: "Confirmation de paiement",
    paynow: "Paiement immédiat",
    SMSConfirm: "Veuillez payer selon le message reçu sur votre téléphone et cliquer sur le bouton de confirmation pour continuer.",
    pay_label: "Montant",
    auth_label: "Pré-autorisation",
    price_tips: "Votre solde peut être retiré sur demande. Il peut fallu 1 à 5 jours ouvrables pour apparaître sur votre compte de paiement.",
    auth_tips: "Un montant de pré-autorisation de {0}{1} est obligatoire. Le montant réel de la location sera déduit lors du retour du power bank.",
    pay_type: "Veuillez sélectionner votre méthode de paiement préférée",
    submit: "Confirmer le paiement",
    msg_loading: "Chargement...",
    msg_fail_title: "Avertissement",
    msg_fail_payment: "Échec de l'initiation du paiement de la caution",
    msg_fail_order: "Échec de la création de la commande de location",
    msg_fail_support: "Le système n'est pas pris en charge",
    msg_fail_confirm: "Confirmer",
    msg_fail_retry: "Réessayer",
    msg_fail_cancel: "Annuler"
  },
  mine: {
    title: "Profil utilisateur",
    wallet: "Mon portefeuille",
    balance: "Mon solde",
    deposit: "Caution",
    wallet_in: "Recharger",
    wallet_out: "Retirer",
    wallet_log: "Historique du portefeuille",
    rental_history: "Historique des locations",
    payment_title: "Méthodes de paiement",
    download_app: "Télécharger l'application",
    settings: "Paramètres",
    help: "Aide",
    logout: "Déconnexion",
    login_tips: "Veuillez vous connecter",
    msg_fail_title: "Erreur",
    msg_fail_update: "Échec de la modification. Veuillez réessayer",
    msg_loading: "Chargement...",
    msg_fail_user: "Erreur lors de la récupération des informations utilisateur. Voulez-vous réessayer ?",
    edit_profile: "Modifier le profil",
    join_us: "Nous rejoindre",
    join_us_details: "Obtenez une station Blitz dans votre établissement"
  },
  msg: {
    appoffline: "L'application n'a pas encore été lancée, veuillez patienter",
    deletecard: "Êtes-vous sûr de vouloir supprimer cette carte ?",
    no_phone: "Le numéro de téléphone est requis",
    loading: "Chargement...",
    title: "Indication",
    success: "Opération réussie",
    error: "Erreur inconnue. Veuillez réessayer plus tard",
    roleerror: "Permissions insuffisantes. Veuillez consulter l'administrateur.",
    neterror: "Échec de la connexion réseau. Veuillez réessayer plus tard",
    confirm: "Confirmer",
    retry: "Réessayer",
    cancel: "Annuler",
    title_fail: "Avertissement",
    vieworder: "Voir la commande",
    success_payment: "Paiement terminé",
    success_buy: "Achat terminé",
    fail_payment: "Échec du paiement",
    keyword: "Mot-clé",
    ispayorder: "Veuillez confirmer si le paiement a été effectué",
    unpay: "Non payé",
    yespay: "Payé",
    notopen: "Pas encore ouvert"
  },
  result: {
    tips: "Pour consulter les commandes et autres emplacements de stations, veuillez télécharger l'application.",
    download: "Télécharger l'application",
    title: "Location confirmée",
    gotit: "Compris",
    price_plan: "Tarif de recharge",
    msg_success: "Location réussie",
    msg_tips_loading: "Le power bank est en cours d'éjection, veuillez patienter...",
    msg_result_loading: "Le résultat du paiement est en cours de confirmation...",
    msg_fail_confirm: "Confirmer",
    btn_usage: "Note d'utilisation",
    btn_return: "Note de retour",
    deposit: "Caution",
    msg_fail_content: "Échec de la demande. Veuillez réessayer.",
    price_label: "par heure",
    price_info: "Gratuit pour les {mianfei} premières minutes, frais journaliers maximum de {ccurrency}{fengding}. La caution sera automatiquement déduite lorsque la location atteint {ccurrency}{yajin}",
    tips_1: "Veuillez récupérer le power bank N°{number} comme indiqué sur l'image",
    tips_2: "Veuillez organiser les câbles et insérer le power bank dans la fente avec le côté marqué de [flèches vers le bas]",
    msg_note_usage: "Le power bank est équipé de 3 types de câbles, veuillez choisir celui adapté à votre appareil.",
    msg_note_return: "Veuillez organiser les câbles et insérer le power bank dans la fente avec le côté marqué de [flèches vers le bas]",
    return_info: "Lors du retour, assurezvous que les câbles sont bien rangés et insérez le côté avec les puces métalliques dans une fente disponible jusqu'à ce qu'il atteigne le fond et se stabilise.",
    download_tips: "Pour louer notre power bank, vous pouvez choisir l'une des options suivantes"
  },
  result_msg: {
    loading: "Chargement...",
    refresh: "Actualiser"
  },
  order: {
    title: "Historique des locations",
    in_use: "En cours",
    ended: "Terminé",
    msg_error: "Échec de la demande",
    order_number: "N°",
    order_details: "Détails de la commande",
    order_zj_shop: "Lieu de location",
    order_zj_time: "Heure de location",
    order_gh_shop: "Lieu de retour",
    order_gh_time: "Heure de retour",
    order_use_time: "Temps d'utilisation",
    order_amount: "Montant total",
    not_on_rent: "Pas en location",
    renting: "En location",
    undone: "Non terminé",
    returned: "Retourné",
    questions: "Questions",
    timeout_to_return: "Délai dépassé pour le retour",
    suspended_for_billing: "Suspendu pour facturation"
  },
  order_item: {
    order_number: "N°",
    venue_rented: "Lieu de récupération",
    time_rented: "Heure de récupération",
    venue_returned: "Lieu de retour",
    time_returned: "Heure de retour",
    charge_standard: "Tarif",
    charge_standard_info: "{pJifei} {pCurrency} par heure (premiers {pMian} mins gratuits)",
    rent_occurred: "Location effectuée",
    returned: "Retourné",
    unreturned: "Non retourné",
    type_0: "Non terminé",
    type_1: "En location",
    type_2: "Annulé",
    type_3: "Retourné",
    type_4: "Erreur survenue",
    type_5: "Dépassement de délai",
    min: "Min",
    payment: "Paiement"
  },
  setting: {
    title: "Paramètres",
    lang: "Langue"
  },
  help: {
    title: "FAQ",
    rentals: "Locations",
    venues: "Établissements",
    payments: "Paiements"
  },
  wallet_in: {
    title: "Recharge de solde",
    price_label: "Montant de la recharge",
    price_placeholder: "Veuillez entrer le montant de la recharge",
    balance: "Solde actuel",
    price_auto: "Choisir le montant du paiement",
    price_tips: "Votre solde peut être retiré sur demande. Il peut fallu 1 à 5 jours ouvrables pour apparaître sur votre compte de paiement.",
    submit: "Soumettre",
    loading: "Chargement...",
    paying: "Redirection vers la page de paiement...",
    msg_title: "Conseils",
    msg_fail_order: "Échec de la création de l'ordre de recharge",
    msg_fail_payment: "Échec de l'initiation du paiement de recharge",
    msg_fail_retry: "Réessayer"
  },
  wallet_out: {
    title: "Retrait",
    price_label: "Montant du retrait",
    price_placeholder: "Veuillez entrer le montant du retrait",
    balance: "Solde actuel",
    balance_all: "Tout retirer",
    deposit: "Caution",
    deposit_tips: "Il y a une commande de location en cours. La caution de {pyajin} n'est pas remboursable",
    submit: "Soumettre",
    apply: "Appliquer",
    confirm: "Confirmer",
    loading: "Chargement...",
    msg_fail_price: "Le montant du retrait est incorrect",
    msg_fail_balance: "Le montant du retrait ne peut pas dépasser le solde actuel",
    msg_fail_submit: "Veuillez remplir toutes les informations requises",
    msg_title: "Erreur",
    msg_success_content: "Remboursement réussi",
    confirmtitle: "Conseils",
    confirmcontent: "Le portefeuille actuel ne prend pas en charge le retrait en espèces. Veuillez enregistrer vos coordonnées pour le traitement manuel du remboursement",
    payee_name: "Nom du bénéficiaire",
    payee_bankcard: "Numéro de carte bancaire",
    payee_phone: "Téléphone",
    cancelText: "Annuler",
    confirmText: "Refaire une demande"
  },
  map: {
    在线: "Ouvert",
    离线: "Fermé",
    title: "Station à proximité",
    result_msg: "Aucune station trouvée à proximité",
    msg_title: "Erreur",
    no_support: "Désolé ! Votre navigateur ne prend pas en charge les services de localisation",
    my_position: "Ma position",
    distance: "Distance :",
    shop_time: "Heures",
    free: "Disponible à la location",
    return: "Fentes vides disponibles",
    shop_title: "Détails de l'établissement",
    address: "Adresse",
    go_here: "Y aller",
    nav_help: "Aide",
    nav_search: "Rechercher",
    locate: "Localiser"
  },
  scanQr: {
    NotAllowedError: "Vous devez autoriser l'accès à la caméra",
    NotFoundError: "Il n'y a pas de caméra sur cet appareil",
    NotSupportedError: "Contexte sécurisé requis (HTTPS, localhost)",
    NotReadableError: "La caméra est en cours d'utilisation",
    OverconstrainedError: "L'installation de la caméra n'est pas appropriée",
    StreamApiNotSupportedError: "Ce navigateur ne prend pas en charge l'API de streaming"
  },
  payment: {
    payment_title: "Méthodes de paiement",
    pay_type: "Veuillez ajouter les détails de votre carte",
    add_payment_card: "Ajouter une carte de paiement",
    add_payment: "Ajouter un paiement"
  },
  shop: {
    title: "Station à proximité",
    search_station: "Rechercher une station",
    search_station_tips: "Veuillez entrer le nom de la station",
    shop_power_banks: "Power Banks",
    shop_empty_slots: "Fentes vides",
    shop_address: "Adresse",
    shop_business_hours: "Heures d'ouverture",
    shop_directions_station: "Itinéraire vers la station",
    shop_scan_qrcode: "Scanner le code QR"
  }
};
